import React from 'react';
import { createSvgIcon } from '../IconBase';

export default createSvgIcon(
  <path d="M5.88 4.12L13.76 12l-7.88 7.88L8 22l10-10L8 2z" />,
  'ArrowForwardIos',
);
